import React from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';

export default function TabletLandscape({ children, invert }) {
    const query = invert ? '(max-width: 900px) or (min-width: 1201px)' : '(min-width: 901px) and (max-width: 1200px)';
    return <MediaQuery query={query}>{children}</MediaQuery>;
}
TabletLandscape.propTypes = {
    invert: PropTypes.bool
};
TabletLandscape.defaultProps = {
    invert: false
};
